import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: any) => ({
  privacyPolicy: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  agreementText: {
    marginBottom: 10,
    fontSize: '14px',
  },
  privacy: {
    fontSize: '16px',
    cursor: 'pointer',
    color: theme.typography.color,
  },
}))

export default useStyles
